module.exports = __webpack_public_path__ + "img/pratichego_login_dark.7234b3d1.png";